module.exports = __webpack_public_path__ + "static/img/ddhzyk-img9.67a938b4.jpg";